import { onMounted, onUnmounted } from 'vue'

const POLL_INTERVAL_MS = 3 * 60 * 1000
const ASSET_HASH_RE = /\/assets\/index-([a-z0-9]+)\.(?:js|css)/i

export const useVersionCheck = () => {
  let initialHash: string | null = null
  let intervalId: number | undefined
  let notified = false

  const fetchCurrentHash = async (): Promise<string | null> => {
    try {
      const res = await fetch(`/index.html?_=${Date.now()}`, { cache: 'no-store' })
      if (!res.ok) return null
      const html = await res.text()
      const match = html.match(ASSET_HASH_RE)
      return match ? match[1] : null
    } catch {
      return null
    }
  }

  const check = async () => {
    if (notified) return
    const current = await fetchCurrentHash()
    if (!current || !initialHash) return
    if (current !== initialHash) {
      notified = true
      document.dispatchEvent(new CustomEvent('errorSnack', {
        detail: { text: 'Je k dispozici nová verze aplikace. Obnovte prosím stránku.' }
      }))
      if (intervalId !== undefined) {
        clearInterval(intervalId)
        intervalId = undefined
      }
    }
  }

  onMounted(async () => {
    initialHash = await fetchCurrentHash()
    if (!initialHash) return
    intervalId = window.setInterval(check, POLL_INTERVAL_MS)
  })

  onUnmounted(() => {
    if (intervalId !== undefined) clearInterval(intervalId)
  })
}
